import { SubjectManager } from '../util/subjectManager';

export const calendarEventsSyncService = new SubjectManager();
